import Head from "next/head";
import React from "react";
import Meta from "../../components/Meta";
import Image from "next/image";

const PrivacyPolicy = () => {
  return (
    <div>
      <Meta title="PrivacyPolicy || Impactoverse " />
      <div className="pt-[5.5rem] lg:pt-24">
        {/* <!-- TOS --> */}
        <section className="dark:bg-jacarta-800 relative py-16 md:py-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
            <Image
              width={1519}
              height={773}
              priority
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full w-full object-cover"
            />
          </picture>
          <div className="container">
            <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
              PRIVACY POLICY
            </h1>
            <div className="article-content mx-auto max-w-[48.125rem]">
              <h2 className="mb-2 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                PRIVACY POLICY
              </h2>
              <p className="dark:text-jacarta-300">
                {
                  "The following document governs and details the Privacy Policy of Impactoverse, which is our web-based digital marketplace for Impact DOTs, marketing and campaign driving platform among other features. On our website, the privacy of all of our users, customers, and other members is protected and respected. This policy has been drafted in order to declare our website’s data protection and data collection practices by explaining specifically how we protect users’ data, and what measures have been taken in order to be in compliance with different local and global privacy laws. This policy is written for all the users, gamers, and members and (herein collectively will be called “users”) to understand how our website (“we”, “our”, and “Impactoverse”) uses, collects, shares, and protects users’ information and data. We request our users to read this privacy policy statement before using our website and services. The users of our website’s services will be assumed to be in agreement with our privacy statement after we have published this Privacy Policy on/through our website."
                }
              </p>
              {/*  <p className="dark:text-jacarta-300">
                PLEASE READ THESE TERMS OF SERVICE CAREFULLY AS THEY CONTAIN
                IMPORTANT INFORMATION AND AFFECT YOUR LEGAL RIGHTS. AS OUTLINED
                IN SECTION 16 BELOW, THEY INCLUDE A MANDATORY ARBITRATION
                AGREEMENT AND className ACTION WAIVER WHICH (WITH LIMITED
                EXCEPTIONS) REQUIRE ANY DISPUTES BETWEEN US TO BE RESOLVED
                THROUGH INDIVIDUAL ARBITRATION RATHER THAN BY A JUDGE OR JURY IN
                COURT.
              </p>
               <p className="dark:text-jacarta-300">
                BY CLICKING TO ACCEPT AND/OR USING OUR SERVICE, YOU AGREE TO BE
                BOUND BY THESE TERMS AND ALL OF THE TERMS INCORPORATED HEREIN BY
                REFERENCE. IF YOU DO NOT AGREE TO THESE TERMS, YOU MAY NOT
                ACCESS OR USE THE SERVICE.
              </p>

               <p className="dark:text-jacarta-300">
                Impactoverse is not a wallet provider, exchange, broker,
                financial institution, or creditor. Impactoverse provides a
                peer-to-peer web3 service that helps users discover and directly
                interact with each other and Impact DOTs available on public
                blockchains. We do not have custody or control over the Impact DOTs or
                blockchains you are interacting with and we do not execute or
                effectuate purchases, transfers, or sales of Impact DOTs. To use our
                Service, you must use a third-party wallet which allows you to
                engage in transactions on blockchains.
              </p>

               <p className="dark:text-jacarta-300">
                Because we have a growing number of services, we sometimes need
                to provide additional terms for specific services (and such
                services are deemed part of the “Service” hereunder and shall
                also be subject to these Terms). Those additional terms and
                conditions, which are available with the relevant service, then
                become part of your agreement with us if you use those services.
                In the event of a conflict between these Terms and any
                additional applicable terms we may provide for a specific
                service, such additional terms shall control for that specific
                service.
              </p> */}

              <h2 className="mb-2 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                COLLECTION OF DATA
              </h2>

              <p className="dark:text-jacarta-300">
                Our website collects information that is necessary for the
                purpose of delivering our products and services. Personal
                information includes (but is not limited to) the full name and
                e-mail, age along with other data (processed automatically) of
                the user. The information which will be collected in this
                process will be used to provide services to the user as well as
                in order to communicate with that user through e-mail and/or
                newsletters. Some information on our website will be gatheredcls
                automatically through different tools and plugins.
              </p>

              <h2>2.1. Users&apos; Information Collection.</h2>

              <p className="dark:text-jacarta-300">
                There will be a collection of information from all of our users
                when they create an account on our website if they will use any
                of our given services. The information that will be provided to
                us includes but is not limited to:
              </p>
              <p className="dark:text-jacarta-300">
                <b>a. </b>Full Name
              </p>
              <p className="dark:text-jacarta-300">
                {" "}
                <b>b. </b>Email address
              </p>

              <p className="dark:text-jacarta-300">
                <b>c. </b>Address (In case if a user wants to run a fundrasie
                campaign for an orginaization we will collect address and
                references as well).
              </p>
              <p className="dark:text-jacarta-300">
                <b>d. </b>Users Google’s or Facebook’s credentials (if user opt
                in using these services)
              </p>
              <p className="dark:text-jacarta-300">
                <b>e. </b>Users&apos; Third-Party Related Information
              </p>
              <p className="dark:text-jacarta-300">
                {" "}
                <b>f. </b>Impact DOTs and Polygon Related Information of The User.
              </p>
              <p className="dark:text-jacarta-300">
                <b>g. </b>Any additional information relating to the users that
                they provide us directly through our website or indirectly
                through our platform or online presence such as ‘cookies’.
              </p>

              <p className="dark:text-jacarta-300">
                <b>f.</b> They want to run a campaign (to fundraise) then we
                take info to verify address and identity and info on the
                organization, and references We use stripe which has its own
                verification and takes card details, we don’t store the
                information related to credit or debit cards.
              </p>

              <h2>2.2. Automatic Information Collection</h2>

              <p className="dark:text-jacarta-300">
                Our website will also collect specific and general information
                that is collected through the website’s addons and plugins for
                the purpose of rendering normal services. This type of
                information includes (but is not limited to) the usage of our
                services by users, referring nodes, device OS and its type,
                language and its preference, and date and time of users’
                browsing history.
              </p>

              <p className="dark:text-jacarta-300">
                Please note that none of the information collected from users
                will be sold however, in order to make our services better we
                may use the information in aggregate form which means that the
                privacy of individual users will remain intact. We may share
                such collected information with third parties services
                providers.
              </p>

              <h2 className="mb-2 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                3. USE OF COOKIES
              </h2>

              <p className="dark:text-jacarta-300">
                Our website uses, collects, and stores cookies on users’
                devices. This cookie policy is written according to the privacy
                rights and user rights policies and we are letting our customers
                know that their data may be collected and they can contact us if
                they want to have their data removed. A cookie is a log file
                that collects certain information and is stored on the
                user&apos;s or visitor’s device or personal computer. This
                information will be provided back to the device if such a user
                or visitor makes a return visit. The most common types of
                cookies are session cookies and permanent cookies.
              </p>

              <p className="dark:text-jacarta-300">
                Session cookies are temporary cookies that are deleted once the
                user exits the browser while permanent cookies remain in the
                user’s or visitor’s browser until the cookie log files are
                either deleted by the user or expired on their own. Mainly we
                use cookies in order to:
              </p>
              <p className="dark:text-jacarta-300">
                <b>i. </b>Understand how visitors are arriving at our website.
              </p>
              <p className="dark:text-jacarta-300">
                <b>ii. </b>In order to monitor the usage of our website visitors
                and traffic.
              </p>
              <p className="dark:text-jacarta-300">
                <b>iii. </b>Remember when a user last visited our website and if
                the cookie persists continuing that user’s usage from the last
                time.
              </p>
              <p className="dark:text-jacarta-300">
                <b>iv. </b>In order to keep track for analysis we may store
                analytical cookies.
              </p>
              <p className="dark:text-jacarta-300">
                <b>v. </b>Track for the purpose of marketing.
              </p>
              <p className="dark:text-jacarta-300">
                <b>vi. </b>for error reporting.
              </p>
              <p className="dark:text-jacarta-300">
                <b>vii. </b>for customer services.
              </p>
              <p className="dark:text-jacarta-300">
                Please note that the cookie does not contain any personal
                identifying information. Users can also change their browser
                settings to ensure that the collection of cookies is disabled.
                However, doing so will make many of our services ineffectual.
              </p>
              <h2 className="mb-2 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                4. THIRD-PARTY LINKS
              </h2>

              <p className="dark:text-jacarta-300">
                We rely on third-party platforms in order to render our
                services. For the purpose of storing and hosting our data we
                primarily use hosting services. Please note that all of these
                services are changeable and we may use other alternatives in
                case we find new, better, and improved third-party platforms.
                Apart from sharing some of our data with our third-party
                platform partners, we will not share, lease, or sell any
                personal user information to a third party (unless specifically
                required by legal authorities for lawful purposes). There might
                also be a presence of third-party tracking and analytical
                services links on our website that may also include the services
                of Google Analytics which may help us track users’ session
                activity, bounce rate, time of stay, and general traffic
                analytics. Most of these links will only be there in order to
                help us provide our services.
              </p>

              <p className="dark:text-jacarta-300">
                Please note that any links that are on or through our website
                are there either for marketing purposes or for other services as
                a requirement for the working of our website. These links may or
                may not be associated or affiliated with us in any way. We use
                the following third-party services.
              </p>
              <p className="dark:text-jacarta-300">
                Please note that none of the information collected from users
                will be sold however, in order to make our services better we
                may use the information in aggregate form which means that the
                privacy of individual users will remain intact. We may share
                such collected information with third parties services
                providers.
              </p>
              <p className="dark:text-jacarta-300">
                <b>a. </b>Google Analytics for analytically checking activities
                on our website.
              </p>
              <p className="dark:text-jacarta-300">
                <b>b. </b>Stripe for payment purposes.
              </p>
              <p className="dark:text-jacarta-300">
                <b>c. </b>Engagebay for managing subscriptions, sales and
                customer care.
              </p>
              <p className="dark:text-jacarta-300">
                We do not collect any information collected by these third-party
                services. Nor do we share or use any personal data of any user
                or member and hence we are not responsible for any stealing,
                hack, theft, or otherwise unlawful use of any of the member’s or
                user’s data which is provided for any of the services rendered
                by third-party platforms. All the information on these platforms
                is collected in accordance with the official privacy policy of
                these relevant platforms.
              </p>
              <h2 className="mb-2 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                5. PROTECTION AND SHARING OF CONSUMERS AND USERS&apos; DATA
              </h2>
              <p className="dark:text-jacarta-300">
                We are committed to protecting the personal data of consumers
                and users to the best of our ability. Data security is necessary
                and therefore in compliance with global data privacy laws, we
                have implemented measures in order to make sure that all data
                belonging to the users, buyers and sellers and visitors of our
                website is well protected. We have made sure that all the
                transactions on and through our website are going through
                well-protected payment platforms. Our website neither collects
                any payment-related information nor we control it.
              </p>
              <p className="dark:text-jacarta-300">
                We May Share Users’ Information In the Following Instances:
              </p>
              <p className="dark:text-jacarta-300">
                <b>a. </b>When we are required by a court of law or legal
                authority to do so.
              </p>
              <p className="dark:text-jacarta-300">
                <b>b. </b>When our business is transferred or sold to a new
                company or owner and in that transaction, the data stored by us
                will also be transferred to the new owner.
              </p>
              <p className="dark:text-jacarta-300">
                <b>c. </b>We may store and transfer the personal data of the
                users out of the European Union regions in order to better
                provide our services. This step will be taken in order to make
                our services better. Users of our services from the EU zone
                hereby acknowledge that their data can be stored on hosting
                servers that are outside the jurisdiction of the EU zone.
              </p>
              <p className="dark:text-jacarta-300">
                <b>d. </b>
                We will share the users’ data with our service providers ( such
                as web-hosting providers, payment partners, etc.), affiliates,
                marketing partners, business partners, and others who have legal
                rights to access users’ data.
              </p>

              <h2 className="mb-2 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                6. PRIVACY RIGHTS UNDER GDPR AND OTHER USER RIGHTS
              </h2>
              <p className="dark:text-jacarta-300">
                In compliance with the GDPR and CCPA other user privacy rights,
                this statement has been provided for all the users of our
                website who are purchasing any of our products or using any of
                our services. All the users have the right to access their
                personal information and they have the right to know how their
                data is being stored on our website. Users can also have their
                data removed or transferred from our website.
              </p>
              <p className="dark:text-jacarta-300">
                Under GDPR and you have the following rights as a consumer,
                user, and purchaser:
              </p>
              <p className="dark:text-jacarta-300">
                <b>a. </b>Know what personal data is being collected.
              </p>
              <p className="dark:text-jacarta-300">
                <b>b. </b>Know whether your personal data is sold or disclosed
                and to whom.
              </p>
              <p className="dark:text-jacarta-300">
                <b>c. </b>Access to your personal data.
              </p>
              <p className="dark:text-jacarta-300">
                <b>d. </b>
                Request to delete any personal information about you.
              </p>
              <p className="dark:text-jacarta-300">
                <b>e. </b>
                They have the right to know how our website (including tools and
                protocols) collects their personal data.
              </p>
              <h2 className="mb-2 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                6.1. UK Data Privacy Rights Under GDPR
              </h2>
              <p className="dark:text-jacarta-300">
                We are fully aware of all of your data protection rights. Every
                user is entitled to the following:
              </p>
              <p className="dark:text-jacarta-300">
                <b>a. </b>
                The Right To Access - You have the right to request our platform
                for copies of your personal data.
              </p>
              <p className="dark:text-jacarta-300">
                <b>b. </b>
                The Right To Rectification– You have the right to request that
                we correct (or complete) any information you believe is
                inaccurate (or incomplete) about yourself.
              </p>
              <p className="dark:text-jacarta-300">
                <b>c. </b>
                The Right To Erasure– You have the right to request that we
                erase your personal data, under certain conditions.
              </p>
              <p className="dark:text-jacarta-300">
                <b>d. </b>
                The Right To Restrict Processing– You have the right to request
                that we restrict the processing of your personal data, under
                certain conditions.
              </p>
              <p className="dark:text-jacarta-300">
                <b>e. </b>
                The Right To Object To Processing– You have the right to object
                to our website’s processing of your personal data, under certain
                conditions.
              </p>
              <p className="dark:text-jacarta-300">
                <b>f. </b>
                The Right To Data Portability– You have the right to request
                that we transfer the data that we have collected to another
                organization, or directly to you, under certain conditions.
              </p>
              <p className="dark:text-jacarta-300">
                <b>g. </b>
                The Right To Complain To A Supervisory Authority– You have the
                right to the Information Commissioner’s Office.
              </p>
              <p className="dark:text-jacarta-300">
                If any user makes a request, we have one month to respond to the
                user. If anyone would like to exercise any of these rights,
                please contact us at this email: support@impactoverse.com.
              </p>
              <h2 className="mb-2 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                7. CCPA COMPLIANCE
              </h2>
              <p className="dark:text-jacarta-300">
                The California Consumer Privacy Act (CCPA) is an act enacted for
                the residents of the USA and specifically for the residents of
                the state of California. This law provides additional
                protections and rights for the protection of personal
                information for California residents. Our website does not sell
                personal information for monetary consideration; however, we do
                work with and share personal information with certain partners
                and third parties unless otherwise stated in this Privacy
                Policy. Under CCPA, users hold certain rights that apply to the
                collection, storage, and sharing of their personal information.
                Users can contact us to exercise their rights under CCPA by
                emailing us at the address below.
              </p>
              <p className="dark:text-jacarta-300">
                Under CCPA users have the following rights.
              </p>
              <p className="dark:text-jacarta-300">
                <b>a. </b>
                Users have the right to know what personal information our
                website collects.
              </p>
              <p className="dark:text-jacarta-300">
                <b>b. </b>
                Users have the right to know who we share their data with.
              </p>
              <p className="dark:text-jacarta-300">
                <b>c. </b>
                Users have the right to deletion of their data.
              </p>
              <p className="dark:text-jacarta-300">
                <b>d. </b>
                Users have the right to receive Non-Discrimination services.
              </p>
              <h2>
                8. NOTICE FOR RESIDENTS IN THE EUROPEAN ECONOMIC AREA REGARDING
                STORAGE OF DATA
              </h2>
              <p className="dark:text-jacarta-300">
                All information users provide to us is stored securely and
                treated with care and respect. The data that we collect from
                users may be transferred to and stored at, a destination outside
                the European Economic Area (&quot;EEA&quot;) such as the United
                States or Canada. It may also be processed by persons operating
                outside the EEA. If we do send users’ data outside the EEA, we
                will take reasonable steps to ensure that the recipient
                implements appropriate measures to protect users’ information.
              </p>
              <h2 className="mb-2 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                9. AGE LIMIT (COPPA NOTICE)
              </h2>
              <p className="dark:text-jacarta-300">
                In compliance with the COPPA act, we are making this notice
                available that anyone under the age of 13 should not provide us
                with any data, specifically personal identifiable information in
                any way. Any such information unknowingly collected by our
                website will be deleted as soon as we become aware of it. The
                only way a minor under the age of 13 can use our website is if
                such a minor has his/her parent’s or guardian’s permission.
                Otherwise, anyone under the age of 13 should not provide us with
                any data, specifically personally identifiable information in
                any way. Any such information unknowingly collected by our
                website will be deleted as soon as we become aware of it.
              </p>
              <h2 className="mb-2 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                10. OPT-OUT RIGHT FROM THE E-MAIL LIST
              </h2>
              <p className="dark:text-jacarta-300">
                All users have the right to opt out of our e-mail list by
                removing themselves from our e-mail list. Users can either
                e-mail us at support@impactoverse.com if they wish to stop
                receiving our e-mails or they can also follow the “unsubscribe
                link” provided at the end of every email.
              </p>
              <h2 className="mb-2 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                11. MODIFICATIONS AND AMENDMENTS IN PRIVACY POLICY
              </h2>
              <p className="dark:text-jacarta-300">
                Any amendments or modifications to this Privacy Policy will be
                made based on the requirements and necessities of our website.
                All updated information will be publicly displayed on this page.
              </p>
              <h2 className="mb-2 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                12. CONTACT
              </h2>
              <p className="dark:text-jacarta-300">
                Any questions, remarks, queries, and feedback regarding any of
                the above-mentioned terms of our Privacy Policy can be directed
                to support@impactoverse.com.
              </p>
            </div>
          </div>
        </section>
        {/* <!-- end TOS --> */}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
